import { useRef } from "react"
import { useSwipeable } from "react-swipeable"

interface UseMessageSwipeWithNavigationOptions {
  onReply: () => void
  onNavigateBack: () => void
  edgeThreshold?: number // Distance from screen edge to trigger navigation (default: 50px)
  replyThreshold?: number // Distance to trigger reply swipe (default: 32px)
}

export function useMessageSwipeWithNavigation({
  onReply,
  onNavigateBack,
  edgeThreshold = 50,
  replyThreshold = 32,
}: UseMessageSwipeWithNavigationOptions) {
  const myRef = useRef<HTMLDivElement>()

  const handlers = useSwipeable({
    onSwipeStart: (eventData) => {
      if (myRef.current) {
        myRef.current.style.transition = "transform 0.2s"
      }
    },
    onSwiping: ({ deltaX, deltaY, initial }) => {
      if (myRef.current && Math.abs(Math.atan2(deltaY, deltaX)) < Math.PI / 8) {
        // Only show visual feedback for message reply swipe, not edge swipe
        const isEdgeSwipe = initial[0] <= edgeThreshold
        if (!isEdgeSwipe) {
          myRef.current.style.transform = `translateX(${Math.max(0, Math.min(deltaX, replyThreshold))}px)`
        }
      }
    },
    onSwiped: ({ deltaX, deltaY, initial }) => {
      if (myRef.current) {
        myRef.current.style.transform = "translateX(0px)"
      }

      // Check if swipe is nearly horizontal
      if (Math.abs(Math.atan2(deltaY, deltaX)) < Math.PI / 8) {
        const isEdgeSwipe = initial[0] <= edgeThreshold

        if (isEdgeSwipe && deltaX >= replyThreshold) {
          // Edge swipe - navigate back to chat list
          onNavigateBack()
        } else if (!isEdgeSwipe && deltaX >= replyThreshold) {
          // Message swipe - reply to message
          onReply()
        }
      }
    },
  })

  const refPassthrough = (el: any) => {
    handlers.ref(el)
    myRef.current = el
  }

  return { ref: refPassthrough, handlers }
}
